/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

export type SearchResult = {
    title: string
    path: string
    label: string
    productCode: string
}

export const selectItemSearchResults = (state): [SearchResult] =>
    state.search?.results || []

export const selectProductFieldValue = (state): string =>
    state.form?.contact?.values?.product || ''

export const selectGeneralSearchResults = state =>
    state.search?.general?.results || []

export const selectGeneralSearchResultsTags = state =>
    state.search?.general?.results
        ?.flatMap(item => item['cq:tags'] || [])
        .uniqueValues()
        .map(tag => tag.path)

export const selectGeneralSearchResultsCount = state =>
    state.search?.general?.amount

export const selectGeneralSearchRedirect = state =>
    state.search?.general?.redirect || undefined
